import { DashboardChartConfig } from "../types";

export enum DashboardChartActions {
	CHANGE_PRODUCT_REPORT = "CHANGE_PRODUCT_REPORT",
	CHANGE_CATEGORY_REPORT = "CHANGE_CATEGORY_REPORT",
	CHANGE_SALES_REPORT = "CHANGE_SALES_REPORT",
	CHANGE_PAYMENT_REPORT = "CHANGE_PAYMENT_REPORT",
	CHANGE_SALES_ADVANCED_REPORT = "CHANGE_SALES_ADVANCED_REPORT",
	CHANGE_ENTIRE_REPORT_CONFIG = "CHANGE_ENTIRE_REPORT_CONFIG",
}

export const chartsConfigReducer = (state: DashboardChartConfig, action: Record<string, any>): DashboardChartConfig => {
	switch (action.type) {
		case DashboardChartActions.CHANGE_ENTIRE_REPORT_CONFIG:
			return { ...state, ...action.data };
		case DashboardChartActions.CHANGE_PRODUCT_REPORT:
			return {
				...state,
				reportProduct: { ...state.reportProduct, ...action.data },
			};
		case DashboardChartActions.CHANGE_SALES_ADVANCED_REPORT:
			return {
				...state,
				reportSalesAdvanced: { ...state.reportSalesAdvanced, ...action.data },
			};
		case DashboardChartActions.CHANGE_CATEGORY_REPORT:
			return {
				...state,
				reportCategory: { ...state.reportCategory, ...action.data },
			};
		case DashboardChartActions.CHANGE_SALES_REPORT:
			return {
				...state,
				reportSales: { ...state.reportSales, ...action.data },
			};
		case DashboardChartActions.CHANGE_PAYMENT_REPORT:
			return {
				...state,
				reportPayment: { ...state.reportPayment, ...action.data },
			};
		default:
			return state;
	}
};
